import { SET_PRODUCTS, SET_PRODUCTS_LOADING, SET_PRODUCTS_ERROR } from "../../actions/productAction";

var initialState = {
  datas: [],
  loading: false,
  error: null,
};

const productReducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case SET_PRODUCTS:
      return {
        ...state,
        datas: action.data,
      };

    case SET_PRODUCTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_PRODUCTS_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    default:
      return state;
  }
};

export default productReducer;
